import { LocalStorageSettings } from './interfaces';

class LocalStorageService {
  get(key: string) {
    return localStorage.getItem(key);
  }

  set(key: string, value: string | LocalStorageSettings) {
    const formattedValue = typeof value === 'string' ? value : JSON.stringify(value);
    return localStorage.setItem(key, formattedValue);
  }

  remove(key: string) {
    return localStorage.removeItem(key);
  }
}

export const localStorageService = new LocalStorageService();
